export default __webpack_public_path__ + "static/media/Zone-6-Master-Plan-Type-H.a4cd12ce.png";